import { API } from "../../../services";
import { handleResponse } from "../../../helpers";
import { API_URL } from "../../../config/appConfig";

const basePath = `${API_URL.idp}/client`;

const tenantHeaders = (tenantId, extra = {}) => ({
  headers: {
    ...(tenantId ? { tenantId: String(tenantId).toLowerCase() } : {}),
    ...extra,
  },
});

const getAllTenantClients = async (tenantId) => {
  return API.get(
    basePath,
    "tenant_clients_list",
    {},
    {},
    tenantHeaders(tenantId, { skipJsonContentType: true })
  ).then(handleResponse);
};

const getTenantClientById = async (clientId, tenantId) => {
  if (!clientId) {
    throw new Error("Tenant client id is missing.");
  }

  return API.get(
    `${basePath}/${clientId}`,
    "tenant_client_by_id",
    {},
    {},
    tenantHeaders(tenantId, { skipJsonContentType: true })
  ).then(handleResponse);
};

const createTenantClient = async (payload = {}, tenantId) => {
  return API.post(
    basePath,
    "tenant_client_create",
    {
      name: String(payload.name || "").trim(),
      grantType: Array.isArray(payload.grantType)
        ? payload.grantType.filter(Boolean).map(String)
        : [],
      allowUserCreation: Boolean(payload.allowUserCreation),
      allowSelfUserCreation: Boolean(payload.allowSelfUserCreation),
      allowLoginViaOTP: Boolean(payload.allowLoginViaOTP),
      redirectUri: Array.isArray(payload.redirectUri)
        ? payload.redirectUri.filter(Boolean).map(String)
        : [],
      roles: Array.isArray(payload.roles)
        ? payload.roles.filter(Boolean).map(String)
        : [],
    },
    tenantHeaders(tenantId)
  ).then(handleResponse);
};

const updateTenantClient = async (clientId, payload = {}, tenantId) => {
  if (!clientId) {
    throw new Error("Tenant client id is missing.");
  }

  return API.put(
    `${basePath}/${clientId}`,
    "tenant_client_update",
    {
      privacyPolicy: String(payload.privacyPolicy || "").trim(),
    },
    tenantHeaders(tenantId)
  ).then(handleResponse);
};

const updateTenantClientRoles = async (clientId, roles, tenantId) => {
  if (!clientId) {
    throw new Error("Client id is missing.");
  }

  return API.put(
    `${basePath}/${clientId}/role`,
    "tenant_client_update_roles",
    {
      roles: Array.isArray(roles) ? roles.filter(Boolean).map(String) : [],
    },
    tenantHeaders(tenantId)
  ).then(handleResponse);
};

const refreshTenantClientSecret = async (clientId, tenantId) => {
  if (!clientId) {
    throw new Error("Client id is missing.");
  }

  return API.put(
    `${basePath}/${clientId}/refreshclientsecret`,
    "tenant_client_refresh_secret",
    {},
    tenantHeaders(tenantId, { skipJsonContentType: true })
  ).then(handleResponse);
};

const updateClientEnabled = async (clientId, enabled, _accessToken, tenantId) => {
  if (!clientId) {
    throw new Error("Client id is missing.");
  }

  const action = enabled ? "enable" : "disable";
  return API.put(
    `${basePath}/${clientId}/${action}`,
    `tenant_client_${action}`,
    {},
    tenantHeaders(tenantId, { skipJsonContentType: true })
  ).then(handleResponse);
};

export const tenantClientService = {
  getAllTenantClients,
  getTenantClientById,
  createTenantClient,
  updateTenantClient,
  updateClientEnabled,
  updateTenantClientRoles,
  refreshTenantClientSecret,
};
